import React, { ReactElement, createContext, useState } from "react";

interface ISingleReplyContext {
  replyingTo: string | null;
  toggleReply: (replyingTo: string | null) => void;
}

const SingleReplyContext = createContext<ISingleReplyContext>({
  replyingTo: null,
  toggleReply: () => {},
});

interface ISingleReplyContextProviderProps {
  children: any;
}

interface ISingleReplyContextConsumerState {
  isReplying: boolean;
  toggleReply: () => void;
  stopReplying: () => void;
}

interface ISingleReplyContextConsumerProps {
  _id: string;
  children: (state: ISingleReplyContextConsumerState) => ReactElement;
}

export function SingleReplyContextProvider({ children }: ISingleReplyContextProviderProps): ReactElement {
  const [value, setValue] = useState<string | null>(null);

  return (
    <SingleReplyContext.Provider
      value={{
        replyingTo: value,
        toggleReply: setValue,
      }}
    >
      {children}
    </SingleReplyContext.Provider>
  );
}

export function SingleReplyContextConsumer({ _id, children }: ISingleReplyContextConsumerProps): ReactElement {
  return (
    <SingleReplyContext.Consumer>
      {({ replyingTo, toggleReply }) => {
        const isReplying = replyingTo !== null && replyingTo === _id;

        return children({
          isReplying,
          toggleReply: () => toggleReply(isReplying ? null : _id),
          stopReplying: () => toggleReply(null),
        });
      }}
    </SingleReplyContext.Consumer>
  );
}
